module.exports = __webpack_public_path__ + "img/the-deep.0f9341e5.png";